"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var qs_1 = __importDefault(require("qs"));
var lodash_1 = require("lodash");
var axios_1 = __importDefault(require("axios"));
var mobx_1 = require("mobx");
var classnames_1 = __importDefault(require("classnames"));
var submit_page_footer_store_1 = require("@hikakaku/shared/stores/estimate_form/common/submit_page_footer_store");
var user_page_footer_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/import_category_based/user_page_footer"));
var convert_case_keys_1 = require("@hikakaku/shared/util/convert_case_keys");
var REQUEST_STRATEGY_PARAMS = { 'estimate_form[request_strategy]': 'import_category_based' };
var NAME_KEY = 'name';
var IMPORT_CATEGORY_KEY = 'import_category_id';
var CONDITION_KEY = 'condition';
var MAP_NAME_KEY = 'map_name';
var PURCHASE_METHOD_KEY = 'purchase_method';
var ITEM_INPUT_KEYS = [IMPORT_CATEGORY_KEY, CONDITION_KEY, NAME_KEY];
var PURCHASE_METHOD_NAME = 'estimate_form[user][purchase_method]';
var EXPECTED_STORE_SIZE_ENDPOINT = '/api/estimate/entries/expected_store_size';
var RECOMMENDED_STORE_ENDPOINT = '/api/estimate/entries/recommended_stores';
var RECOMMEND_ADDITIONAL_PURCHASE_METHOD_STORE_SIZE_MIN = 4;
var UserPageFooterStore = /** @class */ (function () {
    function UserPageFooterStore(props) {
        var _this = this;
        var _a;
        this.component = user_page_footer_1.default;
        this.isSending = false;
        this.forceDisabled = false;
        this.prepareSubmit = function () {
            _this.isSending = true;
        };
        this.handleClickPrevButton = function (event) {
            event.stopPropagation();
            event.preventDefault();
            _this.onClickPrevButton();
        };
        /**
         * 必要なパラメータ
         *          request_strategy
         * 商品      import_category_id, condition
         * ユーザ情報 map_name, purchase_method
         */
        this.updateExpectedStoreSize = function (itemInputListValues, userInputListValue, purchaseMethodOptionValues) {
            var _a;
            var items = itemInputListValues
                .filter(function (input) { return ITEM_INPUT_KEYS.every(function (key) { return Boolean(input[key]); }); })
                .flatMap(function (input) { return ITEM_INPUT_KEYS.map(function (key) { return input[key]; }); })
                .reduce(function (acc, input) {
                var _a;
                return (__assign(__assign({}, acc), (_a = {}, _a[input.name] = input.value, _a)));
            }, {});
            var paramsBase = __assign(__assign(__assign({}, REQUEST_STRATEGY_PARAMS), items), (_a = {}, _a[userInputListValue[MAP_NAME_KEY].name] = userInputListValue[MAP_NAME_KEY].value, _a));
            var selectedPurchaseMethods = userInputListValue[PURCHASE_METHOD_KEY].value;
            var notSelectedPurchaseMethods = purchaseMethodOptionValues.filter(function (method) { return !selectedPurchaseMethods.includes(method); });
            _this.expectedStoreSizeInSelectedPurchaseMethod = undefined;
            _this.expectedStoreSizesInNotSelectedPurchaseMethod = undefined;
            if (Object.keys(items).length === 0 || !userInputListValue[MAP_NAME_KEY].value || selectedPurchaseMethods.length === 0) {
                return;
            }
            _this.fetchExpectedStoreSize(paramsBase, selectedPurchaseMethods)
                .then(function (count) {
                _this.expectedStoreSizeInSelectedPurchaseMethod = count;
                return Promise.all(notSelectedPurchaseMethods.map(function (method) { return _this.fetchExpectedStoreSize(paramsBase, [method]); }));
            })
                .then(function (result) {
                // 多い順にソートしておく
                _this.expectedStoreSizesInNotSelectedPurchaseMethod = (0, lodash_1.zip)(notSelectedPurchaseMethods, result)
                    .map(function (_a) {
                    var label = _a[0], count = _a[1];
                    return ({ label: String(label), count: Number(count) });
                })
                    .sort(function (a, b) { return b.count - a.count; });
                _this.fetchRecommendedStores(itemInputListValues.map(function (input) { return input[IMPORT_CATEGORY_KEY].value; }), itemInputListValues.map(function (input) { return input[CONDITION_KEY].value; }), itemInputListValues.map(function (input) { return input[NAME_KEY].value; }));
            });
        };
        this.fetchExpectedStoreSize = function (paramBase, purchaseMethod) {
            var _a;
            return axios_1.default
                .get(EXPECTED_STORE_SIZE_ENDPOINT, {
                params: __assign(__assign({}, paramBase), (_a = {}, _a[PURCHASE_METHOD_NAME] = purchaseMethod, _a)),
                headers: { 'X-Requested-With': 'XMLHttpRequest' }
            })
                .then(function (_a) {
                var data = _a.data;
                return data.size;
            });
        };
        this.fetchRecommendedStores = function (importCategoryIds, itemCondition, itemName) {
            if (!_this.doesNotHaveAnyExpectedStore) {
                _this.recommendedStores = undefined;
            }
            axios_1.default
                .get("".concat(RECOMMENDED_STORE_ENDPOINT, "?").concat(qs_1.default.stringify((0, convert_case_keys_1.toSnakeKeys)({ importCategoryIds: importCategoryIds, itemCondition: itemCondition, itemName: itemName }))))
                .then(function (_a) {
                var data = _a.data;
                _this.recommendedStores = data.stores;
            })
                .catch(function (error) {
                if (error.response && error.response.data.error) {
                    window.DialogStore.showDialogWithCloseButton('査定可能業者数の取得に失敗しました');
                }
                else {
                    throw JSON.stringify(error);
                }
            });
        };
        this.isLpWatchPage = (_a = props.isLpWatchPage) !== null && _a !== void 0 ? _a : false;
        this.handleClickSubmitButton = props.onClickSubmitButton;
        this.onClickPrevButton = props.onClickPrevButton;
    }
    Object.defineProperty(UserPageFooterStore.prototype, "isSubmitButtonEnabled", {
        get: function () {
            if (this.forceDisabled)
                return false;
            return (this.expectedStoreSizeInSelectedPurchaseMethod !== undefined &&
                this.expectedStoreSizeInSelectedPurchaseMethod > 0) ||
                Boolean(this.recommendedPurchaseMethod);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserPageFooterStore.prototype, "submitButtonText", {
        get: function () {
            return this.isSending
                ? submit_page_footer_store_1.SENDING_BUTTON_TEXT
                : this.doesRecommendPurchaseMethod
                    ? "".concat(this.recommendedPurchaseMethod, "\u3092\u8FFD\u52A0\u3057\u3066\u7121\u6599\u67FB\u5B9A\u3092\u7533\u3057\u8FBC\u3080")
                    : submit_page_footer_store_1.DEFAULT_SUBMIT_BUTTON_TEXT;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserPageFooterStore.prototype, "showsExpectedStoreCounts", {
        get: function () {
            return this.expectedStoreSizeInSelectedPurchaseMethod !== undefined &&
                this.expectedStoreSizeInSelectedPurchaseMethod > RECOMMEND_ADDITIONAL_PURCHASE_METHOD_STORE_SIZE_MIN &&
                this.expectedStoreCounts.length > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserPageFooterStore.prototype, "recommendedPurchaseMethod", {
        get: function () {
            return (this.expectedStoreSizeInSelectedPurchaseMethod !== undefined &&
                this.expectedStoreSizeInSelectedPurchaseMethod <= RECOMMEND_ADDITIONAL_PURCHASE_METHOD_STORE_SIZE_MIN) && (this.expectedStoreSizesInNotSelectedPurchaseMethod !== undefined &&
                this.expectedStoreSizesInNotSelectedPurchaseMethod.length > 0 &&
                this.expectedStoreSizesInNotSelectedPurchaseMethod[0].count > 0)
                ? this.expectedStoreSizesInNotSelectedPurchaseMethod[0].label
                : undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserPageFooterStore.prototype, "doesRecommendPurchaseMethod", {
        get: function () {
            return Boolean(this.recommendedPurchaseMethod);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserPageFooterStore.prototype, "submitButtonClassNames", {
        get: function () {
            return (0, classnames_1.default)("estimateForm-SubmitPageFooter_SubmitButton", {
                "estimateForm-SubmitPageFooter_SubmitButton-disabled": this.doesNotHaveAnyExpectedStore || this.isSending,
                "estimateForm-SubmitPageFooter_SubmitButton-wide": this.doesRecommendPurchaseMethod,
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserPageFooterStore.prototype, "doesNotHaveAnyExpectedStore", {
        get: function () {
            return this.expectedStoreSizeInSelectedPurchaseMethod === 0 &&
                this.expectedStoreSizesInNotSelectedPurchaseMethod !== undefined &&
                (this.expectedStoreSizesInNotSelectedPurchaseMethod.length === 0 ||
                    this.expectedStoreSizesInNotSelectedPurchaseMethod[0].count === 0);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserPageFooterStore.prototype, "expectedStoreCounts", {
        get: function () {
            return (this.expectedStoreSizesInNotSelectedPurchaseMethod || []).filter(function (_a) {
                var count = _a.count;
                return count > 0;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserPageFooterStore.prototype, "submitButtonAnnotationText", {
        get: function () {
            return this.expectedStoreSizeInSelectedPurchaseMethod === 0
                ? '選択した買取方式では買取業者が見つかりませんでした'
                : '買取方法を増やすと該当業者が増える可能性があります';
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], UserPageFooterStore.prototype, "recommendedStores", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Number)
    ], UserPageFooterStore.prototype, "expectedStoreSizeInSelectedPurchaseMethod", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], UserPageFooterStore.prototype, "expectedStoreSizesInNotSelectedPurchaseMethod", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], UserPageFooterStore.prototype, "isSending", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], UserPageFooterStore.prototype, "forceDisabled", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], UserPageFooterStore.prototype, "isSubmitButtonEnabled", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], UserPageFooterStore.prototype, "submitButtonText", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], UserPageFooterStore.prototype, "showsExpectedStoreCounts", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], UserPageFooterStore.prototype, "recommendedPurchaseMethod", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], UserPageFooterStore.prototype, "doesRecommendPurchaseMethod", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], UserPageFooterStore.prototype, "submitButtonClassNames", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], UserPageFooterStore.prototype, "doesNotHaveAnyExpectedStore", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], UserPageFooterStore.prototype, "expectedStoreCounts", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], UserPageFooterStore.prototype, "submitButtonAnnotationText", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], UserPageFooterStore.prototype, "prepareSubmit", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], UserPageFooterStore.prototype, "fetchRecommendedStores", void 0);
    return UserPageFooterStore;
}());
exports.default = UserPageFooterStore;
